import { render } from "./UserSave.vue?vue&type=template&id=57bc0312"
import script from "./UserSave.vue?vue&type=script&lang=js"
export * from "./UserSave.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__